/**
 * Public Footer Component
 * 
 * Footer for all public pages with legal links and risk disclaimer.
 */

import React from "react";
import "./public-footer.css";

export function PublicFooter(): JSX.Element {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="public-footer" role="contentinfo">
      <div className="public-footer__container">
        {/* Legal Links */}
        <nav className="public-footer__legal-nav" aria-label="Legal navigation">
          <a
            href="/terms"
            className="public-footer__link"
            aria-label="Terms of Service"
          >
            Terms
          </a>
          <a
            href="/privacy"
            className="public-footer__link"
            aria-label="Privacy Policy"
          >
            Privacy
          </a>
          <a
            href="/risk-disclaimer"
            className="public-footer__link"
            aria-label="Risk Disclaimer"
          >
            Risk Disclaimer
          </a>
          <a
            href="/refund-policy"
            className="public-footer__link"
            aria-label="Refund Policy"
          >
            Refund Policy
          </a>
          <a
            href="/support"
            className="public-footer__link"
            aria-label="Support"
          >
            Support
          </a>
        </nav>

        {/* Risk Disclaimer */}
        <div className="public-footer__disclaimer">
          <p className="public-footer__disclaimer-text">
            Trading involves risk and may result in losses. Use at your own discretion.
          </p>
        </div>

        {/* Copyright */}
        <div className="public-footer__copyright">
          <p className="public-footer__copyright-text">
            © {currentYear} Zakyam AI Trader. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default PublicFooter;

